export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M18.131 6H5.87a1 1 0 0 0-.833 1.555l6.132 9.197a1 1 0 0 0 1.664 0l6.131-9.197A1 1 0 0 0 18.131 6Z"/>
</svg>
`;
